import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DeviceInfoService } from 'src/app/services/device-info.service';

@Component({
	selector: 'app-mobility-custom-select',
	templateUrl: './mobility-custom-select.component.html',
	styleUrls: ['./mobility-custom-select.component.scss'],
})
export class MobilityCustomSelectComponent implements OnInit {
	_device = inject(DeviceInfoService);
	@Input() values: any[] = [];
	@Input() displayKey: string = '';
	@Input() valueKey: string = '';
	@Input() multiple = false;
	@Input() parentControl: FormControl = new FormControl(<typeof this.values>[]);

	control: FormControl;

	@Output() readonly valueChange = new EventEmitter<typeof this.values>();

	displayFn(value: any): string {
		return this.displayKey ? value[this.displayKey] : value;
	}

	valueFn(value: any): any {
		return this.valueKey ? value[this.valueKey] : value;
	}

	constructor() {}

	ngOnInit(): void {
		this.control = this.parentControl ?? new FormControl(<typeof this.values>[]);
	}
}
